/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
  // Functie om tekst nodes te vinden en te vervangen
  const findAndReplaceText = function (element) {
    // Doorloop alle child nodes
    if (element.childNodes && element.childNodes.length > 0) {
      element.childNodes.forEach((node) => {
        // Als het een tekstnode is en "QUANTITY_" bevat
        if (node.nodeType === 3 && node.textContent.includes("QUANTITY_")) {
          // Vervang alleen het "QUANTITY_XXX" gedeelte, behoud de rest
          const newText = node.textContent.replace(
            /QUANTITY_[^(]*/g,
            "Bulkkorting ",
          );
          node.textContent = newText;
        } else if (node.nodeType === 1) {
          // Als het een element is, doorzoek recursief
          findAndReplaceText(node);
        }
      });
    }
  };

  // Zoek zowel de main cart als mini-cart discount elementen
  const discountElements = document.querySelectorAll(
    ".line-item__discount-list, .mini-cart__discount",
  );
  discountElements.forEach(findAndReplaceText);

  // Extra controle voor specifieke mini-cart elementen
  const miniCartItems = document.querySelectorAll(
    ".mini-cart__discount-list, .mini-cart__discount",
  );
  miniCartItems.forEach(findAndReplaceText);

  // Observeer DOM-veranderingen voor dynamisch geladen elementen
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            const discounts = node.querySelectorAll(
              ".line-item__discount-list, .mini-cart__discount, .mini-cart__discount-list",
            );
            discounts.forEach(findAndReplaceText);
          }
        });
      }
    });
  });

  // Start observatie op het hele document
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  // Aangepaste countdown functie voor meerdere elementen
  function startCountdowns() {
    // Zoek alle countdown elementen
    const countdownElements = document.querySelectorAll(
      ".countdown-timer, #countdown",
    );

    if (countdownElements.length === 0) return; // Stop als er geen elementen zijn

    // Check of het vandaag zaterdag is
    const today = new Date();
    const isSaturday = today.getDay() === 6; // 0 is zondag, 6 is zaterdag

    if (!isSaturday) {
      // Als het geen zaterdag is, verberg de countdown elementen
      countdownElements.forEach((el) => {
        const parentBanner = el.closest(".product-meta__text");
        if (parentBanner) {
          parentBanner.style.display = "none";
        } else {
          el.style.display = "none";
        }
      });
      return;
    }

    // Stel einddatum in op het einde van de huidige zaterdag (23:59:59)
    const endOfToday = new Date(today);
    endOfToday.setHours(23, 59, 59, 999);
    const countdownDate = endOfToday.getTime();

    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countdownDate - now;

      if (distance < 0) {
        clearInterval(x);
        return;
      }

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var countdownText = hours + "u " + minutes + "m " + seconds + "s ";

      // Update alle countdown elementen
      countdownElements.forEach((el) => {
        el.innerHTML = countdownText;
      });
    }, 1000);
  }

  // Start de countdowns
  startCountdowns();
});
